import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class DebugOverlay extends Component {
	static propTypes = {
		debugInfo: PropTypes.shape({
			currentSource: PropTypes.shape({
				src: PropTypes.string.isRequired,
			}).isRequired,
			qualityLevels: PropTypes.shape({
				levels: PropTypes.arrayOf(
					PropTypes.shape({
						bitrate: PropTypes.number.isRequired,
						height: PropTypes.number.isRequired,
						width: PropTypes.number.isRequired,
						label: PropTypes.string.isRequired,
						id: PropTypes.string.isRequired,
					})
				).isRequired,
				selectedIndex: PropTypes.number.isRequired,
			}),
			stats: PropTypes.object,
		}),
		onDismiss: PropTypes.func,
	};

	dismiss = e => {
		if (this.props.onDismiss) {
			this.props.onDismiss(e);
		}
	};

	handleClick = e => {
		e.preventDefault();
		e.stopPropagation();
	};

	render() {
		if (!this.props.debugInfo) {
			return null;
		}

		const { currentSource, qualityLevels, stats } = this.props.debugInfo;
		const selectedQualityLevel =
			qualityLevels.selectedIndex !== -1 && qualityLevels.levels[qualityLevels.selectedIndex];

		const textLines = [
			`Source: ${currentSource && currentSource.src}`,
			'QualityLevels:',
			...qualityLevels.levels
				.sort(sortQualityLevels)
				.map(x => `${x.id === selectedQualityLevel ? '*' : ' '} ${x.width}x${x.height} ${x.bitrate} ${x.label}`),
			'Stats:',
			...Object.entries(stats).map(([key, val]) => `  ${key}: ${val}`),
		];

		return (
			<pre
				style={{
					position: 'absolute',
					resize: 'none',
					boxSizing: 'border-box',
					width: '100%',
					height: '100%',
					padding: '10px',
					margin: 0,
					backgroundColor: 'rgba(0, 0, 0, .4)',
					color: 'rgb(255, 255, 255)',
					fontSize: '15px',
					fontFamily: 'Arial',
					overflow: 'auto',
					zIndex: 1,
					lineHeight: '120%',
				}}
			>
				{textLines.join('\n')}
				{/* TODO: Fix this the next time the file is edited. */}
				{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
				<div style={{ position: 'relative', top: '10px', right: '10px', cursor: 'pointer' }} onClick={this.dismiss}>
					X
				</div>
			</pre>
		);
	}
}

/* eslint-disable no-underscore-dangle */
export function getDebugInfo(player) {
	const qualityLevels = typeof player.qualityLevels === 'function' ? player.qualityLevels() : undefined;
	const el = player.tech_ && player.tech_.el_;
	let stats = player.tech_ && player.tech_.vhs && player.tech_.vhs.stats && { ...player.tech_.vhs.stats };
	if (el) {
		stats = {
			...stats,
			audioDecodedByteCount: el.webkitAudioDecodedByteCount,
			videoDecodedByteCount: el.webkitVideoDecodedByteCount,
			decodedFrameCount: el.webkitDecodedFrameCount,
			droppedFrameCount: el.webkitDroppedFrameCount,
		};
	}
	return {
		currentSource: player.currentSource(),
		qualityLevels: qualityLevels
			? {
					levels: Array.from(qualityLevels).map(x => ({ ...x })),
					selectedIndex: qualityLevels.selectedIndex,
			  }
			: undefined,
		stats,
	};
}
/* eslint-enable no-underscore-dangle */

function sortQualityLevels(a, b) {
	return a - b;
}
